<template>
  <c-stack>
    <Contact1 />
  </c-stack>
</template>

<script>
import Contact1 from "../components/contact-page/contact1.vue";

export default {
  name: "Contact",
  components: {
    Contact1,
  },
};
</script>

<style></style>
